export default {
  header: 'Event tags',
  empty: 'No event tags have been created yet.',
  confirmDeleteMessage: 'Events that carry this tag keep it.',
};
